import type { AssetCreationRequest } from '@graphql/default/types';
import { AssetCreationRequestStatus } from '@graphql/default/types';
import type {
  AcceptedFilesStatuses,
  InputFile,
} from '@shared/components/uploader/interfaces/files.interface';

export const mapProcessingUpdatedStatusFiles = (
  responseFiles: AssetCreationRequest[],
  stateFiles: InputFile[],
): InputFile[] => {
  const responseFilesMap = new Map(
    responseFiles.map((responseFile: AssetCreationRequest) => [
      responseFile.id,
      responseFile,
    ]),
  );

  const mapServerStatusToLocal = (
    serverStatus: AssetCreationRequestStatus,
  ): AcceptedFilesStatuses => {
    switch (serverStatus) {
      case AssetCreationRequestStatus.Completed:
        return 'complete';
      case AssetCreationRequestStatus.Failed:
        return 'error';
      case AssetCreationRequestStatus.Validated:
        return 'processing';
      case AssetCreationRequestStatus.New:
        return 'processing';
      default:
        return 'processing';
    }
  };

  return stateFiles
    .map((stateFile: InputFile) => {
      const responseFile = responseFilesMap.get(stateFile.uploadId);
      if (!responseFile) return null;

      const serverStatus = mapServerStatusToLocal(responseFile.status);
      const stateStatus = stateFile.status;

      if (stateStatus === serverStatus) return null;
      const isFileHasErrorsMessages =
        serverStatus === 'error' && (responseFile.errors?.length ?? 0) > 0;
      if (isFileHasErrorsMessages) {
        const errorMessage = responseFile.errors?.[0];
        if (errorMessage) {
          return {
            ...stateFile,
            status: serverStatus,
            error: errorMessage,
          };
        }
      }

      return {
        ...stateFile,
        status: serverStatus,
      };
    })
    .filter((file): file is InputFile => file !== null);
};
